import { createAction } from '@reduxjs/toolkit';
import set from 'lodash/set';
import get from 'lodash/get';

export const createReducerState = ({ property, prefix, options, initial }) => {
  const action_change = createAction(
    prefix !== '' ? `${prefix}_CHANGE` : 'CHANGE',
  );
  const action_reset = createAction(
    prefix !== '' ? `${prefix}_RESET_TO_INITIAL` : 'RESET_TO_INITIAL',
  );

  const initialState = (() => {
    const base = {};
    set(base, property, initial);
    return property !== '' ? base : initial;
  })();

  const actions = {
    action_change,
    action_reset,
  };

  const actionsArray = Object.values(actions);

  const additionalSetters =
    options.additionalSetters && options.additionalSetters(prefix);

  const reducers = {
    [action_change.type]: (state, action) => {
      additionalSetters &&
        additionalSetters[action_change.type]?.(state, action);
      set(state, property, action.payload);
    },
    [action_reset.type]: (state) => {
      additionalSetters && additionalSetters[action_reset.type]?.(state);
      set(state, property, initial);
    },
  };

  const asyncExecuter =
    (params) =>
    async ({ dispatch, state }) => {
      try {
        let data;
        if (typeof params === 'function') {
          data = params(get(state, property));
        } else {
          data = params;
        }
        dispatch(action_change(data));
      } catch (e) {
        console.error({ e });
      }
    };

  const setAllBuilder = (builder) => {
    Object.keys(reducers).forEach((key) => {
      builder.addCase(
        actionsArray.find((x) => x.type === key),
        reducers[key],
      );
    });
  };

  const resetAll =
    () =>
    ({ dispatch }) => {
      dispatch(action_reset());
    };

  return {
    actions,
    actionsArray,
    reducers,
    initialState,
    asyncExecuter,
    setAllBuilder,
    resetAll,
  };
};
